import { useCallback, useState } from 'react';
import { MouseSensor, TouchSensor, useSensors, useSensor, } from '@dnd-kit/core';
export function useDraggable({ onDragOver, onDragMove }) {
    const [isDragging, setIsDragging] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const handleDragStart = useCallback(({ active }) => {
        setIsDragging(true);
        setActiveItem(active.data.current);
    }, []);
    const handleDragEnd = useCallback(({ activatorEvent, active, delta, over }) => {
        setActiveItem(null);
        setIsDragging(false);
        onDragOver({ activatorEvent, active, delta, over });
    }, [onDragOver]);
    const handleDragMove = useCallback(({ activatorEvent, active, delta, over }) => {
        onDragMove({ activatorEvent, active, delta, over });
    }, [onDragMove]);
    const mouseSensor = useSensor(MouseSensor, {
        activationConstraint: {
            distance: 5,
        },
    });
    const touchSensor = useSensor(TouchSensor, {
        activationConstraint: {
            delay: 5,
            tolerance: 5,
        },
    });
    const sensors = useSensors(mouseSensor, touchSensor);
    return {
        isDragging,
        activeItem,
        handleDragStart,
        handleDragEnd,
        handleDragMove,
        sensors,
    };
}
//# sourceMappingURL=useDraggable.js.map